import { Box, SxProps, Theme, Typography } from '@mui/material';
import { ReactNode, memo } from 'react';
import { useTranslation } from 'react-i18next';

export const HelpRequestSectionTitle = memo(({ title }: { title: string }) => (
    <Typography typography="openSans.subtitle1Medium" mb="20px">
        {title}
    </Typography>
));
HelpRequestSectionTitle.displayName = 'HelpRequestSectionTitle';

export const HelpRequestSectionBody = memo(
    ({ children, sx }: { children: ReactNode; sx?: SxProps<Theme> }) => (
        <Typography typography="openSans.body2" sx={sx}>
            {children}
        </Typography>
    ),
);
HelpRequestSectionBody.displayName = 'HelpRequestSectionBody';

export const HelpRequestSectionSubTitle = memo(
    ({ title }: { title: string }) => (
        <Typography
            typography="openSans.body2"
            color="grey.600"
            fontWeight={700}
            mb="20px"
        >
            {title}
        </Typography>
    ),
);
HelpRequestSectionSubTitle.displayName = 'HelpRequestSectionSubTitle';

export const HelpRequestOptionsList = memo(
    ({ options }: { options: readonly string[] }) => {
        const { t } = useTranslation();

        return (
            <Box component="ul" sx={{ pl: 3, mt: 1 }}>
                {options.map((option) => (
                    <Typography
                        key={option}
                        component="li"
                        typography="openSans.body2"
                    >
                        {t(option)}
                    </Typography>
                ))}
            </Box>
        );
    },
);

HelpRequestOptionsList.displayName = 'HelpRequestOptionsList';
